module.exports = __webpack_public_path__ + "fonts/Inter-600-cyrillic58.06ab411.woff2";